export class ClsPedidoUbicacionModel {
    public Latitud_Ini: number = 0;

    public Longitud_Ini: number = 0;

    public Latitud_Fin: number = 0;

    public Longitud_Fin: number = 0;
}